import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import Fotter from "./Fotter";
import { Link } from "react-router-dom";
import SettingSidebar from "./SettingSidebar";
import { BASE_URL } from "../Pages/Config";
import axios from "axios";
import Cookies from "js-cookie";
import BuyerName from "./BuyerName";
import ContactInfo from "./ContactInfo";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { formatDate } from "../components/dateUtils";

export default function SettingSold() {
  const [products, setProducts] = useState([]);
  const [productsbid, setProductsBid] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showToast, setToastMessage] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [ratingText, setRatingText] = useState("");
  const [selectedBuyerId, setSelectedBuyerId] = useState(null);
  const [SelectedProductId, setSelectedProductId] = useState("");
  const [satisfactionLevel, setSatisfactionLevel] = useState("");
  const [ratingEmoji, setRatingEmoji] = useState("");

  useEffect(() => {
    const fetchProducts = async () => {
      const userId = Cookies.get("user_id");
      if (!userId) return;

      try {
        const response = await axios.get(
          `${BASE_URL}/all_sold_user_item.php?user_id=${userId}&t=${Date.now()}`,
        );

        console.log("API Response product:", response.data);

        if (response.data.success && Array.isArray(response.data.data)) {
          setProducts(response.data.data);
        } else {
          setProducts([]);
        }
      } catch (error) {
        console.error("Failed to fetch products", error);
        setProducts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, []);

  const userId = Cookies.get("user_id");

  const fetchuserproductbid = async () => {
    const userId = Cookies.get("user_id");
    if (!userId) return;
    try {
      const response = await axios.get(
        `${BASE_URL}/user_product_bids.php?id=${userId}&t=${Date.now()}`,
      );
      if (response.data.success && Array.isArray(response.data.data)) {
        setProductsBid(response.data.data);
      } else {
        setProductsBid([]);
      }
    } catch (error) {
      console.error("Failed to fetch bids", error);
      setProductsBid([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchuserproductbid();
  }, []);

  const fetchratingemoji = async () => {
    const userId = Cookies.get("user_id");
    if (!userId) return;
    try {
      const response = await axios.get(
        `${BASE_URL}/get_rating_emoji.php?t=${Date.now()}`,
      );
      if (response.data.success && Array.isArray(response.data.data)) {
        setRatingEmoji(response.data.data);
      } else {
        setRatingEmoji([]);
      }
    } catch (error) {
      console.error("Failed to fetch bids", error);
      setRatingEmoji([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchratingemoji();
  }, []);

  // console.log("emoji", ratingEmoji);
  const [ratingWord, setRatingword] = useState("");
  const fetchNegativeWords = async () => {
    const userId = Cookies.get("user_id");
    if (!userId) return;
    try {
      const response = await axios.get(
        `${BASE_URL}/get_rating_negative_word.php?t=${Date.now()}`,
      );
      if (response.data.success && Array.isArray(response.data.data)) {
        setRatingword(response.data.data);
      } else {
        setRatingword([]);
      }
    } catch (error) {
      console.error("Failed to fetch bids", error);
      setRatingword([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNegativeWords();
  }, []);

  //console.log("words", ratingWord);
  const [rate, setRating] = useState("");

  const fetchuserrating = async () => {
    const userId = Cookies.get("user_id");
    if (!userId) return;
    try {
      const response = await axios.get(
        `${BASE_URL}/get_rating_by_user_id.php?id=${userId}&t=${Date.now()}`,
      );
      console.log("User Rated :", response);
      if (response.data.success && Array.isArray(response.data.data)) {
        console.log("user_rated", response.data.data);
        setRating(response.data.data);
      } else {
        setRating([]);
      }
    } catch (error) {
      console.error("Failed to fetch bids", error);
      setRating([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Call immediately
    fetchuserrating();

    // Set interval to call every 2 seconds (2000 ms)
    const interval = setInterval(() => {
      fetchuserrating();
    }, 2000);

    // Clear interval on component unmount
    return () => clearInterval(interval);
  }, []);

  const [badWordError, setBadWordError] = useState("");
  const handleSubmitRating = async () => {
    if (!selectedBuyerId) {
      // alert("Buyer ID is missing.");
      toast.warning("Something wrong. try again later !");
      return;
    }

    if (!satisfactionLevel) {
      // alert("Please select your level of satisfaction.");
      toast.warning("Please select your level of satisfaction.");
      return;
    }

    const trimmedText = ratingText.trim();

    // Check for bad words if ratingWord has data
    if (ratingWord.length > 0 && ratingWord[0].words) {
      const wordList = ratingWord[0].words
        .split(",")
        .map((word) => word.trim().toLowerCase())
        .filter((word) => word !== "");

      const lowerText = trimmedText.toLowerCase();
      const foundWord = wordList.find((word) => lowerText.includes(word));

      if (foundWord) {
        setBadWordError(
          `Your feedback contains a restricted word: "${foundWord}"`,
        );
        return;
      } else {
        setBadWordError(""); // clear previous error
      }
    }

    // Log all values
    // console.log("Submitting Rating with the following data:");
    // console.log("massage_sender (userId):", userId);
    // console.log("product_id:", SelectedProductId);
    // console.log("seller_id:", selectedBuyerId);
    // console.log("satisfaction:", satisfactionLevel);
    // console.log("message:", trimmedText);

    try {
      const res = await axios.post(`${BASE_URL}/submit_buyer_rating.php`, {
        massage_sender: userId,
        product_id: SelectedProductId,
        buyer_id: selectedBuyerId,
        satisfaction: satisfactionLevel,
        message: trimmedText,
      });

      console.log(res);

      if (res.data.success) {
        // setToastMessage("Thank you for your feedback!");
        toast.success("Thank you for your feedback!");
        fetchuserrating();
      } else {
        toast.warning("Failed to submit rating.");
        // setToastMessage("Failed to submit rating.");
        fetchuserrating();
      }
    } catch (err) {
      // console.error("Rating error:", err);
      toast.error("Error submitting feedback. Try again Later !");
      // setToastMessage("Error submitting feedback.");
    } finally {
      setShowModal(false);
      setRatingText("");
      setSatisfactionLevel("");
      setTimeout(() => setToastMessage(""), 3000);
    }
  };

  return (
    <>
      <Navbar />
      <div className="page-info">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="info">
                <Link to="/">
                  <p>HOME </p>
                </Link>
                <span> /</span>
                <Link to="/">
                  <p>FASTTRADE</p>
                </Link>
                <span>/</span>

                <p>SOLD</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="page-settings">
        <div className="container">
          <div className="row">
            <SettingSidebar />
            <div className="col-xl-9 col-lg-9 col-md-12">
              <h2>
                {loading ? (
                  <b>Loading...</b>
                ) : (
                  <b>
                    Sold {products.length}{" "}
                    {products.length === 1 ? "Item" : "Items"}
                  </b>
                )}
              </h2>
              <div
                className="setting-info"
                style={{ background: "transparent" }}
              >
                <div className="row g-4">
                  {loading ? (
                    <div
                      className="loading-overlay"
                      style={{
                        height: "550px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <div className="dot-spinner">
                        {[...Array(8)].map((_, i) => (
                          <div key={i} className="dot-spinner__dot"></div>
                        ))}
                      </div>
                    </div>
                  ) : products.length === 0 ? (
                    <>
                      <img
                        src={`${BASE_URL}/uploads/logo/data_not_found.png`}
                        alt="No Data Found"
                        style={{
                          width: "100%",
                          height: "450px",
                          objectFit: "contain",
                          mixBlendMode: " darken",
                        }}
                      />
                    </>
                  ) : (
                    products.map((product) => {
                      const matchedBid = productsbid.find(
                        (bid) => bid.id === product.id,
                      );
                      const buyerId =
                        product.buy_product_status === "1"
                          ? product.buyer_id
                          : matchedBid?.highest_bidder_id;

                      const ProductId = product.product_id || product.id;

                      return (
                        <div
                          key={product.id}
                          className="col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6 p-0"
                        >
                          <div className="auction-card">
                            <div className="auction-card-img-wrap">
                              <Link
                                to={`/detail/${product.id}`}
                                className="card-img"
                              >
                                <img
                                  src={
                                    product.photo
                                      ? `${BASE_URL}/${product.photo
                                          .split(",")[0]
                                          .trim()}`
                                      : `${BASE_URL}/uploads/logo/icon.png`
                                  }
                                  alt={product.title}
                                />
                              </Link>
                            </div>
                            <div className="auction-card-content">
                              <p style={{ fontSize: "12px" }}>
                                {formatDate(product.closing_time)}
                              </p>
                              <h6>
                                <Link to={`/detail/${product.id}`}>
                                  {product.title}
                                </Link>
                              </h6>
                              <div className="details_buyer">
                                <h6>Item Id</h6> <p>#{product.id}</p>
                              </div>
                              <div className="details_buyer">
                                <h6>Buyer</h6>
                                <p>
                                  <Link to={`/review/${product.user_id}`}>
                                    <BuyerName buyerId={product.winner_id} />
                                  </Link>
                                </p>
                              </div>
                              <div className="details_buyer">
                                <h6>Sold For</h6>
                                <p
                                  style={{
                                    color: "#ebc32f",
                                    fontWeight: "800",
                                  }}
                                >
                                  {product.buy_product_status === "1"
                                    ? product.buy_now
                                    : product.current_price}{" "}
                                  SAR
                                </p>
                              </div>

                              <div className="details_buyer">
                                <h6>Type</h6>
                                <div className="type">
                                  <button>
                                    {product.buy_product_status === "1"
                                      ? "Directly buy"
                                      : "Win by Auction"}
                                  </button>
                                </div>
                              </div>
                              <div className="rate_btn">
                                <button
                                  onClick={() => {
                                    if (!buyerId) {
                                      toast.error(
                                        "Buyer not found for this product.",
                                      );
                                      return;
                                    }

                                    // Check if user already rated this buyer
                                    const alreadyRated = rate.some(
                                      (rating) =>
                                        rating.product_id === ProductId,
                                    );

                                    if (alreadyRated) {
                                      toast.warning(
                                        "You have already rated this Buyer.",
                                      );
                                    } else {
                                      setSelectedBuyerId(buyerId);
                                      setSelectedProductId(ProductId);
                                      setShowModal(true); // open rating modal
                                    }
                                  }}
                                >
                                  Rate Buyer
                                </button>
                              </div>
                              <div
                                className="social_section"
                                style={{
                                  display: "flex",
                                  gap: "8px",
                                  marginTop: "16px",
                                  flexWrap: "wrap", // makes it responsive
                                }}
                              >
                                {/* <ContactInfo buyerId={buyerId} /> */}

                                <ContactInfo
                                  buyerId={buyerId}
                                  itemId={product.id}
                                  productName={product.title}
                                  productType="Sold"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Rating Modal */}
      {showModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10000,
          }}
        >
          <div
            style={{
              backgroundColor: "#fff",
              padding: "30px",
              borderRadius: "8px",
              width: "400px",
              maxWidth: "90%",
              boxShadow: "0 0 10px rgba(0,0,0,0.25)",
            }}
          >
            <h3>Rate THE Buyer</h3>
            <h5 style={{ fontSize: "14px", color: "#888", display: "none" }}>
              Buyer ID: {selectedBuyerId}
            </h5>

            <div style={{ marginBottom: "15px" }}>
              <p
                style={{
                  marginBottom: "8px",
                  color: "black",
                  fontWeight: "600",
                }}
              >
                What is your level of satisfaction?
              </p>
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  justifyContent: "center",
                  fontSize: "32px",
                }}
              >
                {[
                  {
                    label: "sad",
                    emoji: (
                      <img
                        src={`${BASE_URL}/uploads/emoji/${ratingEmoji[0].sad_image}`}
                        alt="sad"
                        style={{ width: "40px", height: "40px" }}
                      />
                    ),
                  },
                  {
                    label: "neutral",
                    emoji: (
                      <img
                        src={`${BASE_URL}/uploads/emoji/${ratingEmoji[0].natural_image}`}
                        alt="sad"
                        style={{ width: "40px", height: "40px" }}
                      />
                    ),
                  },
                  {
                    label: "happy",
                    emoji: (
                      <img
                        src={`${BASE_URL}/uploads/emoji/${ratingEmoji[0].happy_image}`}
                        alt="sad"
                        style={{ width: "40px", height: "40px" }}
                      />
                    ),
                  },
                ].map((option) => (
                  <span
                    key={option.label}
                    onClick={() => setSatisfactionLevel(option.label)}
                    className="rating_emoji"
                    style={{
                      border:
                        satisfactionLevel === option.label
                          ? "3px solid #007bff"
                          : "3px solid transparent",
                    }}
                    title={option.label}
                  >
                    {option.emoji}
                  </span>
                ))}
              </div>
            </div>

            <textarea
              rows="4"
              value={ratingText}
              onChange={(e) => {
                setRatingText(e.target.value);
                setBadWordError("");
              }}
              className={badWordError ? "textarea-error " : ""}
              style={{
                width: "100%",
                padding: "10px",
                margin: "10px 0",
                borderRadius: "5px",
              }}
              placeholder="Write your feedback here..."
            ></textarea>

            {badWordError && (
              <div
                style={{ color: "red", marginBottom: "5px", fontSize: "12px" }}
              >
                {badWordError}
              </div>
            )}

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
              }}
            >
              <button
                onClick={handleSubmitRating}
                style={{
                  padding: "8px 12px",
                  backgroundColor: "#007bff",
                  color: "#fff",
                  border: "none",
                  borderRadius: "4px",
                  width: "50%",
                }}
              >
                Submit
              </button>
              <button
                onClick={() => setShowModal(false)}
                style={{
                  padding: "8px 12px",
                  backgroundColor: "#ccc",
                  border: "none",
                  borderRadius: "4px",
                  width: "50%",
                }}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {showToast && (
        <div
          style={{
            position: "fixed",
            bottom: "20px",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "#333",
            color: "#fff",
            padding: "10px 20px",
            borderRadius: "5px",
            zIndex: 9999,
          }}
        >
          {showToast}
        </div>
      )}

      <Fotter />
    </>
  );
}
